import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Focus the field and select any existing text
    this.element.focus();
    this.element.select();
  }
}
